import { format } from 'date-fns'

export const toIsoDateString = (date: Date): string => format(date, 'yyyy-MM-dd')
